import get from 'lodash/fp/get';

export const getLocale = get('lang.displayLocale');

export const getLanguageData = get('lang.displayMessages');
